<template>
  <BgGradation
  v-if="isShow"
  class="welcome_call"
  >
    <router-link
    :to="{ name: 'WelcomeCallQuestion' }"
    class="welcome_call_wrap"
    >
      <div class="logo">
        <img :src="require('@/assets/images/welcomeCall/logo.svg')" alt="">
      </div>
      <div class="text_wrap">
        <p class="text">Tap to start</p>
      </div>

    </router-link>
  </BgGradation>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">
    アクセスエラー<br />coNPusアプリから再度開き直してください。
  </div>
</template>

<script>
import Check from "@/model/getToken";
import BgGradation from '@/components/common/BgGradation.vue';
import Config from '@/config/config'

export default {
  components: {
    BgGradation,
  },
  data() {
    return {
      isShow: true,
    };
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => {
      res = val;
    });
    console.log(res);
    if (!res) {
      this.isShow = false;
    }
  },
};
</script>


<style lang="css" scoped>
.welcome_call {
  padding-top: 40px;
}
.text_wrap {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
.text {
  color: #FFFFFF;
  font-family: Inter;
  font-size: 26px;
  font-weight: 700;
  line-height: 31.47px;
  letter-spacing: -0.01em;
  padding: 6px 0;
  position: relative;
  text-shadow: #17057A40 1px 3px 4px;
}
.text::before, .text::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #fff;
  box-shadow: 0px 3px 4px 0px #17057A40;
  z-index: 0;
}
.text::before {
  top: 0;
  left: 0;
}
.text::after {
  bottom: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/welcomeCall/WelcomeCall.vue